import api from './client.js'

export const mapvetoAPI = {
  create:  (data) => api.post('/mapveto', data),
  get:     (uuid) => api.get(`/mapveto/${uuid}`),
  ban:     (uuid, map) => api.post(`/mapveto/${uuid}/ban`, { map }),
  load:    (uuid) => api.post(`/mapveto/${uuid}/load`),
  recent:  () => api.get('/mapveto'),
  checkin: (uuid) => api.post(`/mapveto/${uuid}/checkin`),
}
